// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2D95M","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__tN_99"};